import {NgModule, ModuleWithProviders} from "@angular/core";
import {CommonModule} from "@angular/common";
import {LoginInfoComponent} from "./login-info/login-info.component";
import {LogoutComponent} from "./logout/logout.component";
import { LastUserInfoComponent } from "./last-user";
import { UtilsModule } from "../utils/utils.module";

@NgModule({
    imports: [
        CommonModule,
        UtilsModule
    ],
    declarations: [
        LoginInfoComponent,
        LogoutComponent,
        LastUserInfoComponent,
    ],
    exports: [
        LoginInfoComponent,
        LastUserInfoComponent,
        LogoutComponent
    ]
})
export class UserModule{}



// WEBPACK FOOTER //
// ./src/app/shared/user/user.module.ts